const login = {
  name: 'trainingCertQueryLogin',
  path: '',
  component: resolve => require(['../../../../../../pages/portal/sbs/training/cert-query/login'], resolve)
}

export default login
